/**
 * Tipos de mensajes que se pueden recibir desde el Backend
 *
 * Una vez recibimos el mensaje en el canal abierto (ReceiveMessage) estos son los tipos de mensaje
 * que procesamos
 */
export enum E_SocketMessageType {
    OBSERVATION = 'Observation',
    GROUPED_OBSERVATION = 'GroupedObservation',
    SECTION = 'section',
    PUMP = 'pump',

    NEW_PATIENT = 'NewPatient',
    DELETE_PATIENT = 'DeletePatient',

    CONFIG_OBSERVATION = 'ConfigObservation',
    LAST_TREATMENT = 'lastTreatment',
    TREATMENT = 'Treatment',
    UPDATE_TREATMENT = 'UpdateTreatment',
    BEACON = 'Beacon',
    SENSOR = 'sensor',
    SECTION_SENSORS = 'sectionSensors',
    ALARM = 'Alarm',
    PATIENT_LOCATION = 'PatientLocation',
    PERSON_DATA = 'PatientData',
    UPDATE_PATIENT = 'UpdatePatient',
    NEW_NOTICE = 'NewNotice',
    DELETE_NOTICE = 'DeleteNotice',
    UPDATE_NOTICE = 'UpdateNotice',
    UPDATE_POINTOFCARE = 'UpdatedPointOfCare',
    NEW_POINTOFCARE = 'NewPointOfCare',
    DELETE_POINTOFCARE = 'DeletePointOfCare',

    UPDATE_MASTER_LIST_ITEM = 'UpdateMasterListItem',
    DELETE_MASTER_LIST_ITEM = 'DeleteMasterListItem',
    ADD_MASTER_LIST_ITEM = 'AddMasterListItem',
    NEW_MASTER_LIST = 'NewMasterList',
    UPDATE_MASTER_LIST = 'UpdateMasterList',

    NEW_DISCHARGE = 'NewDischarge',
    UPDATE_DISCHARGE = 'UpdateDischarge',
    DELETE_DISCHARGE = 'DeleteDischarge',

    NEW_ADMISSION = 'NewAdmission',
    UPDATE_ADMISSION = 'UpdateAdmission',
    DELETE_ADMISSION = 'DeleteAdmission',
    NOTIFICATION_ADMISION_LOCATION_UPDATED = 'AdmissionLocationUpdated',
    DISPLAY_SECTION_LIST = 'DisplaySectionList',
    DISPLAY_LIST = 'DisplayList',
    UPDATE_UNIT = 'UpdateUnit',
    UPDATE_DETAIL_DISPLAY_CONFIG = 'UpdateDetailDisplayConfig',
    UDATE_CHART_CONFIG = 'UpdateChartConfig',
    UPDATE_DISPLAY_CONFIG = 'UpdateDisplayConfig',
    UPDATE_CARD_DISPLAY_CONFIG = 'UpdateCardDisplayConfig',
    UPDATE_SMART_DISPLAY_CONFIG = 'UpdateSmartDisplayConfig',
    UPDATE_NURSE_DISPLAY_CONFIG = 'UpdateNurseDisplayConfig',

    // USER

    UPDATE_PASSWORD = 'UpdatePassword',
    UPDATE_AUTHORITIES = 'UpdateAuthorities',
    DISABLE_USER = 'DisableUser',
    LOCK_USER = 'LockUser',
}
